import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from 'ui-product-approvals-common';
import { MAX_APPROVAL_NOTE_LENGTH, MAX_APPROVAL_TITLE_LENGTH } from '../constants/requestModal';
import { MAX_APPROVERS } from './approvalProcessValidation';
import { jsx as _jsx } from "react/jsx-runtime";
export const maxNumberOfApprovers = MAX_APPROVERS;
export const getModalUse = (approvalOperation, approvalType) => {
  if (approvalOperation === ApprovalOperation.REJECT && (approvalType === ApprovalTypes.DEAL || approvalType === ApprovalTypes.CONNECTED_APP)) {
    return 'danger';
  }
  return undefined;
};
export const getShouldShowFeedbackSurvey = (approvalType, approvalOperation) => approvalType !== ApprovalTypes.QUOTE && (approvalType === ApprovalTypes.DEAL || approvalOperation === ApprovalOperation.APPROVE || approvalOperation === ApprovalOperation.REQUEST);
export const getIsApprovalTitleError = title => title.length > MAX_APPROVAL_TITLE_LENGTH || !title.trim();
/**
 * The validation shared by Request approval and the template process lock.
 * Keep the messages and precedence aligned between those controls.
 */
export const getApprovalProcessDisabledState = ({
  approversCount,
  hasEmptyApprovalStep,
  isMissingHumanApprover
}) => {
  if (!approversCount) {
    return {
      isDisabled: true,
      disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.modal.disabledTooltip.noApprovers"
      })
    };
  }
  if (hasEmptyApprovalStep) {
    return {
      isDisabled: true,
      disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.modal.disabledTooltip.emptyApprovalStep"
      })
    };
  }
  if (isMissingHumanApprover) {
    return {
      isDisabled: true,
      disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.modal.disabledTooltip.noHumanApprover"
      })
    };
  }
  if (approversCount > maxNumberOfApprovers) {
    return {
      isDisabled: true,
      disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.modal.disabledTooltip.tooManyApprovers",
        options: {
          maxNumberOfApprovers
        }
      })
    };
  }
  return undefined;
};
export const getPrimaryButtonDisabledState = ({
  approvalOperation,
  noteContent,
  isNoteTooLong,
  approversCount,
  isDueDateValid,
  canEditApprovalTitle,
  approvalTitle,
  isApprovalTitleError,
  hasEmptyApprovalStep,
  isMissingHumanApprover,
  hasUnavailableTemplateApprover
}) => {
  const noteIsTooLong = {
    isDisabled: true,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.modal.disabledTooltip.noteTooLong",
      options: {
        maxLength: MAX_APPROVAL_NOTE_LENGTH
      }
    })
  };
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        if (!isDueDateValid) {
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.invalidDueDate"
            })
          };
        }
        if (canEditApprovalTitle && isApprovalTitleError) {
          if (!approvalTitle.trim()) {
            return {
              isDisabled: true,
              disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "productApprovals.modal.disabledTooltip.approvalTitleRequired"
              })
            };
          }
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.approvalTitleTooLong",
              options: {
                maxLength: MAX_APPROVAL_TITLE_LENGTH
              }
            })
          };
        }
        if (hasUnavailableTemplateApprover) {
          return {
            isDisabled: true,
            disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.modal.disabledTooltip.unavailableTemplateApprover"
            })
          };
        }
        const approvalProcessDisabledState = getApprovalProcessDisabledState({
          approversCount,
          hasEmptyApprovalStep,
          isMissingHumanApprover
        });
        if (approvalProcessDisabledState) {
          return approvalProcessDisabledState;
        }
        if (isNoteTooLong) {
          return noteIsTooLong;
        }
        return {
          isDisabled: false,
          disabledTooltip: undefined
        };
      }
    case ApprovalOperation.CANCEL:
    case ApprovalOperation.REJECT:
    case ApprovalOperation.REQUEST_CHANGES:
      if (!noteContent) {
        return {
          isDisabled: true,
          disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.modal.disabledTooltip.noteRequired"
          })
        };
      }
      if (isNoteTooLong) {
        return noteIsTooLong;
      }
      return {
        isDisabled: false,
        disabledTooltip: undefined
      };
    case ApprovalOperation.APPROVE:
    default:
      if (isNoteTooLong) {
        return noteIsTooLong;
      }
      return {
        isDisabled: false,
        disabledTooltip: undefined
      };
  }
};